import * as _ from 'underscore'

import { DataProvider, Dictionary, TypeHelper, ReferenceTypeComponent, CommonHelper } from "../helpers"
import { KeyType } from '../helpers/dictionary'

import { OpOperator, OpView } from '../models/core'
import { OpOperatorSettings, SESSION } from '../models/custom'
import { IReferenceType } from '../models/util/interfaces'
import { Enums } from '../models/common'
import { Utils } from '../models/util/utils'

export class DataProviderLocalStorage {

    // Consts

    public static get LOCAL_STORAGE_OPERATION_DELAY() { return 1000 }

    // Consts End


    // Members

    public cultureName: string = null
    public loggedOperator: OpOperator = null
    public loggedOperatorSettings: OpOperatorSettings = null
    public dictionaries = new Dictionary<Dictionary<IReferenceType>>(null)
    private localStorageTimeout: any[] = null
    private localStorageContent: Dictionary<any> = null
    private operatorSession: SESSION = null

    // Members End


    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getLoggedOperator = (): OpOperator => {
        return this.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator)
    }

    // OperatorSettings
    public getLoggedOperatorSetting = (settingType: Enums.SimaxOperatorSetting, querryLocalStorage: boolean = false): any => {
        if (this.loggedOperatorSettings == null) {
            this.loggedOperatorSettings = new OpOperatorSettings()
        }

        if (querryLocalStorage || !this.loggedOperatorSettings.getSetting(settingType)) {
            const settings: any = this.getFromLocalStorage(Enums.SimaxLocalStorageKey.OperatorSettings)
            let value: any = null

            if (settings != null) {
                value = settings[Enums.SimaxOperatorSetting[settingType]]

                if (value == null) {
                    value = null
                }
            }

            this.loggedOperatorSettings.setSetting(settingType, value)
        }

        return this.loggedOperatorSettings.getSetting(settingType)
    }

    public getLoggedOperatorSettings = (querryLocalStorage: boolean = false): OpOperatorSettings => {
        TypeHelper.iterateEnum(Enums.SimaxOperatorSetting, (key: Enums.SimaxOperatorSetting, name: string) => {
            if (key !== Enums.SimaxOperatorSetting.Unknown) {
                this.dataProvider.LocalStorage.getLoggedOperatorSetting(key)
            }
        })

        return this.dataProvider.LocalStorage.loggedOperatorSettings
    }

    public containsLoggedOperatorSetting = (settingType: Enums.SimaxOperatorSetting): boolean => {
        return this.loggedOperatorSettings && this.loggedOperatorSettings.containsSetting(settingType)
    }

    public saveLoggedOperatorSetting = (settingType: Enums.SimaxOperatorSetting, value: any, saveDelayTime: number = DataProviderLocalStorage.LOCAL_STORAGE_OPERATION_DELAY): void => {
        if (!this.loggedOperatorSettings) {
            this.loggedOperatorSettings = new OpOperatorSettings()
        }

        const lastValue = this.getLoggedOperatorSetting(settingType)

        if (lastValue != value || !angular.equals(lastValue, value)) {
            let settings: any = this.getFromLocalStorage(Enums.SimaxLocalStorageKey.OperatorSettings)

            if (!settings) {
                settings = {}
            }

            settings[Enums.SimaxOperatorSetting[settingType]] = OpOperatorSettings.convertSettingToJSON(settingType, value)

            this.saveToLocalStorage(Enums.SimaxLocalStorageKey.OperatorSettings, settings, saveDelayTime)
            this.loggedOperatorSettings.setSetting(settingType, value)
        }
    }

    public saveLoggedOperatorSettings = (loggedOperatorSettings: Dictionary<any>): void => {
        if (!this.loggedOperatorSettings) {
            this.loggedOperatorSettings = new OpOperatorSettings()
        }

        if (loggedOperatorSettings != null) {
            const settings: any = {}

            loggedOperatorSettings.keys().forEach(t => {
                const settingType: Enums.SimaxOperatorSetting = <Enums.SimaxOperatorSetting>parseInt(t.toString())

                this.loggedOperatorSettings.setSetting(settingType, loggedOperatorSettings.tryGetValue(t))
                settings[Enums.SimaxOperatorSetting[t]] = this.loggedOperatorSettings.getSettingJSON(settingType)
            })

            this.saveToLocalStorage(Enums.SimaxLocalStorageKey.OperatorSettings, settings)
        }
    }

    public removeLoggedOperatorSettings = (): void => {
        if (this.loggedOperatorSettings) {
            this.loggedOperatorSettings.removeSettings()
        }

        this.removeFromLocalStorage(Enums.SimaxLocalStorageKey.OperatorSettings)
    }

    public removeLoggedOperatorContext = (): void => {
        this.removeLoggedOperatorSettings()

        if (this.loggedOperatorSettings) {
            this.loggedOperatorSettings.removeSettings()
        }

        TypeHelper.iterateEnum(Enums.SimaxLocalStorageKey, (key: Enums.SimaxLocalStorageKey, name: string) => {
            this.removeFromLocalStorage(key)
        })
    }

    //ActiveViews
    public getActiveViews = (querryLocalStorage: boolean = false): OpView[] => {
        return this.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.ActiveViews)
    }

    public saveActiveViews = (activeViews: OpView[]) => {
        if (activeViews) {
            this.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.ActiveViews, activeViews)
        }
    }

    //Dictionaries
    public saveDictionaries = (dictionaries: Dictionary<any>) => {
        //debugger
        if (dictionaries) {
            var dictionariesToJson: Dictionary<Dictionary<IReferenceType>> = new Dictionary<Dictionary<IReferenceType>>(null)
            var mainKeys: (string | number)[] = dictionaries.keys()
            for (var mk: number = 0; mk < mainKeys.length; mk++) {
                var refTypeDict: Dictionary<IReferenceType> = dictionaries.tryGetTypedValue<Dictionary<IReferenceType>>(mainKeys[mk])
                var refTypeDictToJson: Dictionary<IReferenceType> = new Dictionary<IReferenceType>(null)
                var refTypeKeys: (string | number)[] = refTypeDict.keys()
                dictionariesToJson.addOrUpdate(mainKeys[mk], refTypeDictToJson)
                if (refTypeKeys.length > 0) {
                    var refObj: any
                    var toJsonEnable: boolean = Utils.isJsonSupport(refTypeDict.tryGetValue(refTypeKeys[0]))
                    for (var rtk: number = 0; rtk < refTypeKeys.length; rtk++) {
                        refObj = refTypeDict.tryGetValue(refTypeKeys[rtk])
                        if (refObj) {
                            refTypeDictToJson.addOrUpdate(refTypeKeys[rtk], toJsonEnable ? refObj.toJSON(true) : refObj)
                        }
                    }
                }
            }
            this.saveToLocalStorage(Enums.SimaxLocalStorageKey.BusinessDictionary, dictionariesToJson)
            this.saveToLocalStorage(Enums.SimaxLocalStorageKey.UpdateDate, new Date())
        }
    }

    public getDictionaries = (): JQueryPromise<Dictionary<Dictionary<IReferenceType>>> => {
        if (this.dictionaries && this.dictionaries.length > 0) {
            return $.Deferred().resolve(this.dictionaries).promise()
        }

        return this.restoreDictionaries(true)
    }

    public getDictionariesLocal = (): Dictionary<Dictionary<IReferenceType>> => {
        return this.dictionaries
    }

    public restoreDictionaries = (querryLocalStorage: boolean = false): JQueryPromise<Dictionary<Dictionary<IReferenceType>>> => {
        if (this.dictionaries && this.dictionaries.length > 0 && !querryLocalStorage) {
            return $.Deferred().resolve(this.dictionaries).promise()
        }

        if (!this.dictionaries) {
            this.dictionaries = new Dictionary<Dictionary<IReferenceType>>(null, KeyType.Number)
        }

        const dictionaries: any = this.getFromLocalStorage(Enums.SimaxLocalStorageKey.BusinessDictionary)
        let promise: JQueryPromise<any> = $.when<any>()

        if (dictionaries && dictionaries.dictionary) {
            const result: Dictionary<Dictionary<IReferenceType>> = new Dictionary<Dictionary<IReferenceType>>(null, KeyType.Number)

            for (var key in dictionaries.dictionary) {
                const dictTmp: Dictionary<IReferenceType> = Dictionary.restore<IReferenceType>(dictionaries.dictionary[key])

                if (dictTmp && dictTmp.length > 0) {
                    result.addOrUpdate(key, dictTmp)
                }
            }

            let mainKeys: Enums.ReferenceType[] = <number[]>result.keys()
            mainKeys = ReferenceTypeComponent.orderReferenceObjectTypeByHierarchy(mainKeys)//Zachowana kolejność analizy typów referencyjnych począwszy od liści do korzenia

            for (let mk: number = 0; mk < mainKeys.length; mk++) {
                const refTypeDict: Dictionary<IReferenceType> = result.tryGetTypedValue<Dictionary<IReferenceType>>(mainKeys[mk])
                const refTypeKeys: (string | number)[] = refTypeDict.keys()

                if (refTypeKeys.length > 0) {
                    for (let rtk: number = 0; rtk < refTypeKeys.length; rtk++) {
                        refTypeDict.addOrUpdate(refTypeKeys[rtk], ReferenceTypeComponent.createReferenceObject(mainKeys[mk], refTypeDict.tryGetValue(refTypeKeys[rtk])))
                    }

                    promise = promise.then(() => {
                        return ReferenceTypeComponent
                            .loadReferenceObjectNavigationProperties(this.dataProvider, mainKeys[mk], refTypeDict.values())
                            .then(() => {
                                this.dictionaries.addOrUpdate(mainKeys[mk], refTypeDict)
                            })
                    })

                }
            }
        }

        if (!this.dictionaries) {
            this.dictionaries = new Dictionary<Dictionary<IReferenceType>>(null)
        }

        return promise.then(() => {
            return this.dictionaries
        })
    }

    public setDictionary = (referenceType: Enums.ReferenceType, dictionary: Dictionary<IReferenceType>, saveToLocalStorage: boolean = true) => {
        if (!this.dictionaries)
            this.dictionaries = new Dictionary<Dictionary<IReferenceType>>(null)
        this.dictionaries.addOrUpdate(referenceType, dictionary)
        if (saveToLocalStorage) {
            this.saveDictionaries(this.dictionaries)
        }
    }
    public tryGetDictionary = (referenceType: Enums.ReferenceType): Dictionary<IReferenceType> => {
        if (!this.dictionaries)
            this.dictionaries = new Dictionary<Dictionary<IReferenceType>>(null)
        return this.dictionaries.tryGetTypedValue<Dictionary<IReferenceType>>(referenceType)
    }
    public tryGetDictionaryContent = <T extends IReferenceType>(dictionaries: Dictionary<Dictionary<IReferenceType>>, referenceType: Enums.ReferenceType) => {
        if (!dictionaries || !dictionaries.containsKey(referenceType))
            return null
        var dict: Dictionary<IReferenceType> = dictionaries.tryGetValue(referenceType)
        if (!dict)
            return null
        return <T[]>dict.values()
    }

    //Session
    public getOperatorSession = (querryLocalStorage: boolean = false): SESSION => {
        if (querryLocalStorage || !this.operatorSession) {
            var session: any = this.getFromLocalStorage(Enums.SimaxLocalStorageKey.OperatorSession)
            this.operatorSession = session ? new SESSION(session) : null
        }
        return this.operatorSession
    }
    public getOperatorSessionJSON = (querryLocalStorage: boolean = false): any => {
        var session: SESSION = this.getOperatorSession(querryLocalStorage)
        return session ? session.toJSON() : null
    }
    public saveOperatorSession = (session: SESSION): void => {
        this.saveToLocalStorage(Enums.SimaxLocalStorageKey.OperatorSession, session ? session.toJSON() : null, null)
        this.operatorSession = session
    }

    // Te 2 metody nie przynosiły żadnego zysku jeśli chodzi o rozmiar
    // a tylko spowalniały simaxa
    //encodeString: (decoded: any) => {
    //    var buffer = msgpack.encode(decoded)
    //    var string = ''
    //    for (var i = 0; i < buffer.length; i++) {
    //        string += String.fromCharCode(buffer[i])
    //    }
    //    return string
    //},
    //decodeString : (encoded: string) => {
    //    var byteNumbers = new Array(encoded.length)
    //    for (let i = 0; i < encoded.length; i++) {
    //        byteNumbers[i] = encoded.charCodeAt(i)
    //    }
    //
    //    return msgpack.decode(byteNumbers)
    //},

    public clearLocalStorage = () => {
        localStorage.clear()
    }

    public getFromLocalStorage = (localStorageKey: Enums.SimaxLocalStorageKey, defaultValue: any = {}): any => {
        if (!this.localStorageContent) {
            this.localStorageContent = new Dictionary<any>(null)
        }

        if (!this.localStorageContent.containsKey(localStorageKey)) {
            let settings: any = defaultValue
            const lastLocalStorage: any = localStorage.getItem(DataProvider.DOMAIN + Enums.SimaxLocalStorageKey[localStorageKey])

            if (lastLocalStorage) {
                try {
                    settings = JSON.parse(lastLocalStorage)
                } catch (e) {
                    console.warn(`Unable to parse localStorage value for the ${Enums.SimaxLocalStorageKey[localStorageKey]} key.`, e)
                }
            }

            this.localStorageContent.addOrUpdate(localStorageKey, settings)
        }

        return this.localStorageContent.tryGetValue(localStorageKey)
    }

    public saveToLocalStorage = (localStorageKey: Enums.SimaxLocalStorageKey, value: any, time: number = 1000) => {
        if (!this.localStorageContent)
            this.localStorageContent = new Dictionary<any>(null)
        if (!this.localStorageTimeout)
            this.localStorageTimeout = []
        if (this.localStorageTimeout && typeof this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]] != 'undefined') clearTimeout(this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]])

        var doSave = () => {
            try {
                var stringify = JSON.stringify(value)
                localStorage.setItem(CommonHelper.domain + Enums.SimaxLocalStorageKey[localStorageKey], stringify)
                this.localStorageContent.addOrUpdate(localStorageKey, value)
            } catch (e) {
                console.log('Can\'t save settings:', e)
            }
        }

        if (time > 0) {
            this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]] = setTimeout(() => {
                doSave()
            }, time)
        }
        else {
            doSave()
        }
    }
    public removeFromLocalStorage = (localStorageKey: Enums.SimaxLocalStorageKey, time: number = 1000) => {
        if (!this.localStorageContent)
            this.localStorageContent = new Dictionary<any>(null)
        if (!this.localStorageTimeout)
            this.localStorageTimeout = []
        if (this.localStorageTimeout && typeof this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]] != 'undefined') clearTimeout(this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]])

        var doRemove = () => {
            try {
                localStorage.removeItem(CommonHelper.domain + Enums.SimaxLocalStorageKey[localStorageKey])
            } catch (e) {
                console.log('Can\'t save settings:', e)
            }
        }

        if (time >= 0) {
            this.localStorageTimeout[Enums.SimaxLocalStorageKey[localStorageKey]] = setTimeout(() => {
                doRemove()
            }, time)
        }
        else {
            doRemove()
        }
    }

    // Public Methods End
}